import { z } from 'zod';

export const getActionUsersParamsSchema = z.object({
    targetId: z.number(),
    targetType: z.string(),
    type: z.string(),
});
export type GetActionUsersParams = z.infer<typeof getActionUsersParamsSchema>;

export const addRemoveActionParamsSchema = z.object({
    targetId: z.number(),
    targetType: z.string(),
    type: z.string(),
});
export type AddRemoveActionParams = z.infer<typeof addRemoveActionParamsSchema>;
